/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-02-28 15:53:54
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-01-11 00:18:54
 * @FilePath: \baishu_react_ui\src\utils\WidgetFilter\AddressWidgetFilter.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import WidgetFilter from ".";

import negate from "lodash/negate";
import size from "lodash/size";
import union from "lodash/union";

import { BsyUtils } from "../Utils";

export default class ComboCheckWidgetFilter extends WidgetFilter {
    in() {
        var e = arguments;
        return function (t) {
            var i = {};
            BsyUtils.forEach(e, function (t, e) {
                i[e] = !0
            });
            var a = !1;
            return BsyUtils.forEach(t, function (t, e) {
                if (i[e])
                    return !(a = !0)
            }),
                a
        }
    }
    all() {
        var e = arguments;
        return function (t) {
            if (BsyUtils.isObjectEmpty(e))
                return !1;
            var i = {};
            BsyUtils.forEach(t, function (t, e) {
                i[e] = !0
            });
            var a = !0;
            return BsyUtils.forEach(e, function (t, e) {
                if (!i[e])
                    return a = !1
            }),
                a
        }
    }
    eq() {
        var e = arguments;
        return function (t) {
            return !BsyUtils.isObjectEmpty(e) && (size(e) === size(t) && size(union(e, t)) === size(e))
        }
    }
    empty() {
        return function (t) {
            return BsyUtils.isObjectEmpty(t)
        }
    }
    notEmpty() {
        return negate(this.empty())
    }
}
